// extracted by mini-css-extract-plugin
module.exports = {"pageTitleContainer":"PageTitle_pageTitleContainer__1moFD","pageTitleContainerLtr":"PageTitle_pageTitleContainerLtr__3hB4h"};